import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import React from 'react';
import { useAuth } from '.';

type ApiContext = AxiosInstance;

const defaultRequestConfig: AxiosRequestConfig = {
	baseURL: process.env.REACT_APP_CEREBRO_API_ROOT_URL,
};

const Context = React.createContext<ApiContext | null>(null);

export const ApiProvider: React.FC = ({ children }) => {
	const { authToken } = useAuth();

	const api = React.useMemo(() => {
		return axios.create({
			...defaultRequestConfig,

			headers: {
				...defaultRequestConfig.headers,

				Authorization: `Bearer ${authToken}`,
			},
		});
	}, [authToken]);

	return <Context.Provider value={api}>{children}</Context.Provider>;
};

export function useApi() {
	var context = React.useContext(Context);

	if (context == null) throw Error('You tried to consume the ApiContext outside of an ApiProvider!');

	return context;
}
